<template>
  <div class="survey" v-bind:class="headtailClass">
    <div class="survey_info">
      <span class="necessary" v-if="item.required">필수</span>
      <span class="choice_n" v-if="item.answer_flag === 'B'">2문항 선택</span>
    </div>

    <div class="surveyTitle">
      <h3>
        <span class="num">{{item.idx}}</span>
        {{item.title}}
      </h3>
      <div class="img" v-if="imagejimuns.length > 0">
        <img :src="image.url" v-bind:key="image.name" v-for="image in imagejimuns" />
      </div>
    </div>
    <div class="exampleWrap exampleWrap_thum">
      <div class="example_list" v-bind:key="bogi.id" v-for="bogi in bogis">
        <div class="checkbox">
          <input
            v-model="bogi.chk"
            type="checkbox"
            :name="bogi.id"
            :id="bogi.id"
            @change="sendQ(bogi)"
          />

          <label :for="bogi.id">
            <template v-if="bogi.title !=  null">{{bogi.title}}</template>
            <template v-else>
              <img :src="bogi.image.url" />
            </template>
          </label>
        </div>
      </div>
    </div>
    <!-- exampleWrap -->
    <a v-if="item.answer_flag !== 'A'" @click.prevent="sendSum" href class="btn check" title="확인">확인</a>
  </div>
</template>

<script>
import * as R from "ramda";
export default {
  props: ["item", "flag"],
  data() {
    return {
      bogis2: [...this.item.Itemdetails],
      checkedCount: 0,
      CValue: "",
    };
  },
  computed: {
    headtailClass() {
      if (this.item != undefined) {
        if (this.item.first) {
          return "first";
        } else if (this.item.last) {
          return "last";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    bogis() {
      let k = this.item.Itemdetails;
      k = R.map((x) => {
        if (x.image != null && typeof x.image == "string") {
          // console.log(x.image);
          // console.log(typeof x.image);

          x.image = JSON.parse(x.image);
        }

        return x;
      }, k);
      return k;
    },
    imagejimuns() {
      let k = JSON.parse(this.item.jimun_multi);
      k = R.reject((x) => x.type !== "image", k);
      return k;
    },
  },
  methods: {
    sendQ(bogi) {
      let that = this;
      let $that = this;
      this.checkedCount = R.filter((x) => {
        return x.chk;
      }, this.bogis).length;

      //todo: decresed number of user sent
      let _k = this.$store.state.non_answers;
      if (this.checkedCount === 0) {
        _k = R.reject((x) => {
          return x === $that.item.id;
        }, _k);
        _k = R.uniq(_k);
        this.$store.state.non_answers = _k;
      }

      if (this.item.answer_flag[0] === "D") {
        let max_cnt = parseInt(this.item.answer_flag[1]);

        if (this.checkedCount >= max_cnt) {
          this.bogis.forEach((b, i) => {
            if (!b.chk) {
              let f4 = that.bogis[i];
              f4.disabled = "disable";
              that.$set(that.bogis, i, f4);
            }
          });
        } else {
          this.bogis.forEach((b, i) => {
            let f4 = that.bogis[i];
            f4.disabled = null;
            that.$set(that.bogis, i, f4);
          });
        }

        return;
      }
      if (this.item.answer_flag !== "A" && this.item.answer_flag !== "F") {
        // A타입이 아니면 취소
        // BCDE
        return;
      }

      if (this.checkedCount === 0) {
        let _k = this.$store.state.non_answers;

        _k = R.reject((x) => x === this.item.id, _k);
        _k = R.uniq(_k);

        this.$store.state.non_answers = _k;
      } else {
        let _k = this.$store.state.non_answers;
        _k = R.append(this.item.id, _k);
        _k = R.uniq(_k);
        this.$store.state.non_answers = _k;
      }

      // bogi.chk = !bogi.chk;
      this.bogis.forEach((b, i) => {
        if (b.id !== bogi.id) {
          let f4 = this.item.Itemdetails[i];
          f4.chk = false;
          this.$set(this.item.Itemdetails, i, f4);
        }
      });

      let url = this.$Constant.NonItemPost;
      let answer = [bogi.id];

      this.$axios
        .post(url, {
          item_id: this.item.id,
          item_answer: JSON.stringify(answer),
          point: 0,
          item_apply_id: this.item.apply_id,
          item_apply_log_id: this.item.apply_log_id,
          answer_flag: this.item.answer_flag,
          flag: this.flag,

          etc: null,
        })
        .then((resp) => {
          this.item.apply_log_id = resp.data.id;
        });

      if (this.item.next_item_id != null) {
        document.getElementById(this.item.next_item_id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    sendSum() {
      //todo: submit with multiple answers

      let answer = null;

      if (this.item.answer_flag === "C") {
        // 주관식이면
        if (this.CValue === "") {
          return;
        }
        answer = [this.CValue];
      } else {
        answer = R.filter((x) => x.chk == true, this.bogis).reduce((x, y) => {
          x.push(y.id);
          return x;
        }, []);

        if (answer.length === 0) {
          let xMax = 16;
          this.$anime({
            targets: ".survey",
            duration: 550,
            easing: "easeInOutSine",
            translateX: [
              {
                value: xMax * -1,
              },
              {
                value: xMax,
              },
              {
                value: xMax / -2,
              },
              {
                value: xMax / 2,
              },
              {
                value: 0,
              },
            ],
          });
          return;
        }
      }

      let url = this.$Constant.NonItemPost;
      this.$axios
        .post(url, {
          item_id: this.item.id,
          item_answer: JSON.stringify(answer),
          point: 0,
          item_apply_id: this.item.apply_id,
          item_apply_log_id: this.item.apply_log_id,
          answer_flag: this.item.answer_flag,
          flag: this.flag,

          etc: null,
        })
        .then((resp) => {
          this.item.apply_log_id = resp.data.id;
        });

      if (this.item.next_item_id != null) {
        document.getElementById(this.item.next_item_id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }

      let _k = this.$store.state.non_answers;
      _k = R.append(this.item.id, _k);
      _k = R.uniq(_k);
      this.$store.state.non_answers = _k;
    },
  },
};
</script>


<style lang="scss" scoped>
</style>